import { getProgressTasks, saveProgressTasks } from '@/utils/progress'

const progressModel = {
    namespace: 'progress',
    state: {
        progressTasks: [] // { taskId: '', messageType: '', state: DOING // 为了3秒消失处理}
    },
    effects: {
        *getProgressTasks({ payload }, { call, put }) {
            const progressTasks = yield getProgressTasks()

            yield put({
                type: 'init',
                payload: {
                    progressTasks
                }
            })
        }
    },
    reducers: {
        init(state, { payload }) {
            const { progressTasks } = payload
            return {
                ...state,
                progressTasks
            }
        },
        add(state, { payload }) {
            const { progressTasks } = state
            const item = {
                ...(payload || {}),
                taskId: payload.taskId,
                messageType: payload.messageType
            }
            const newProgressTasks = Array.isArray(progressTasks) ? progressTasks.concat(item) : [item]

            saveProgressTasks({ progressTasks: newProgressTasks, currentUser: payload?.currentUser })

            return {
                ...state,
                progressTasks: newProgressTasks
            }
        },
        update(state, { payload }) {
            const { progressTasks } = state

            const newProgressTasks = Array.isArray(progressTasks)
                ? progressTasks.map(item => {
                      if (item.taskId === payload.taskId) {
                          return {
                              ...item,
                              ...payload
                          }
                      }

                      return item
                  })
                : []

            saveProgressTasks({ progressTasks: newProgressTasks, currentUser: payload?.currentUser })

            return {
                ...state,
                progressTasks: newProgressTasks
            }
        },
        remove(state, { payload }) {
            const { progressTasks } = state
            const newProgressTasks = Array.isArray(progressTasks)
                ? progressTasks.filter(item => item.taskId !== payload.taskId)
                : []

            saveProgressTasks({ progressTasks: newProgressTasks, currentUser: payload?.currentUser })

            return {
                ...state,
                progressTasks: newProgressTasks
            }
        }
    }
}

export default progressModel
